export const profile = {
  name: "Oumayma Maili",
  firstName: "Oumayma",
  role: "Backend & DevOps Engineer",
  location: "Oujda, Morocco",
  email: "oumaymamaili@gmail.com",
  phone: "+212 682 808 401",
  github: "https://github.com/oumacode",
  linkedin: "https://linkedin.com/in/oumayma-maili",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Education", href: "#education" },
  { label: "Tech stack", href: "#skills" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Certifications", href: "#certifications" },
  { label: "Achievements", href: "#achievements" },
  { label: "Contact", href: "#contact" },
];

export const heroChips = ["Java & Spring Boot", "DevOps & CI/CD", "Observability"];

export const education = [
  {
    period: "2024 – 2027",
    title: "Engineering Degree in Computer Science",
    school: "ENIAD — Berkane",
  },
  {
    period: "2022 – 2024",
    title: "DUT in Computer Science",
    school: "EST — Oujda",
  },
];

export const skills = [
  {
    category: "Backend Development",
    tone: "pink",
    items: ["Spring Boot", "Spring Integration", "Spring Cloud Gateway", "JPA / Hibernate", "REST APIs","Symfony", "Maven"],
  },
  {
    category: "DevOps & Observability",
    tone: "blue",
    items: [
      "Git",
      "GitHub",
      "GitLab",
      "Docker",
      "Jenkins",
      "GitHub Actions",
      "Prometheus",
      "Grafana",
      "Blackbox Exporter",
    ],
  },
  {
    category: "Programming Languages",
    tone: "lilac",
    items: ["Java", "Python", "JavaScript", "SQL"],
  },
  {
    category: "Databases",
    tone: "peach",
    items: ["PostgreSQL", "MySQL", "Oracle Database", "PL/SQL"],
  },
  {
    category: "Frontend Development",
    tone: "pink",
    items: ["HTML","CSS","React", "Tailwind CSS"],
  },
  {
    category: "Tools & Collaboration",
    tone: "lilac",
    items: ["Postman", "Figma", "Jira", "Confluence", "Slack"],
  },
];

export const experiences = [
  {
    period: "Jul – Aug 2026",
    title: "Java & DevOps Intern",
    company: "SQLI",
    location: "Oujda, Morocco",
    tone: "pink",
    description:
      "Contributed to infrastructure reliability through end-to-end monitoring and to backend data pipelines with Spring Integration.",
    missions: [
      {
        title: "Test environments monitoring",
        points: [
          "Architected and deployed an observability solution for 8 test environments using Prometheus, Grafana, Blackbox Exporter and Docker Compose.",
          "Designed real-time Grafana dashboards to monitor service availability, HTTP response codes and network latency.",
          "Extended supervision to Jenkins CI/CD jobs, tracking build statuses, execution durations and test health across environments.",
        ],
        stack: ["Prometheus", "PromQL", "Grafana", "Blackbox Exporter", "Docker Compose", "Jenkins", "Linux", "GitLab"],
      },
      {
        title: "Spring Integration platform",
        points: [
          "Developed a Java / Spring Integration batch service for daily automated synchronization of partner vendors from CSV files.",
          "Implemented data validation, exception management and automated execution report generation.",
        ],
        stack: ["Java", "Spring Boot", "Spring Integration", "JPA/Hibernate", "PostgreSQL", "Docker", "GitLab"],
      },
    ],
  },
  {
    period: "Jun – Aug 2024",
    title: "Full-Stack Developer Intern",
    company: "FCPO Web & Digital Marketing",
    location: "Oujda, Morocco",
    tone: "peach",
    description:
      "Built full-stack solutions to automate medical clinic scheduling and clinical performance monitoring.",
    missions: [
      {
        points: [
          "Developed an intelligent medical appointment chatbot that automates patient booking, rescheduling and cancellation.",
          "Created a real-time administrative dashboard to track clinical consultations and KPIs.",
        ],
        stack: ["React", "Symfony", "MySQL", "REST API", "Git", "GitHub"],
      },
    ],
  },
];

export const projects = [
  {
    tag: "PFA project · 2026",
    tone: "blue",
    title: "AutoFlow",
    live: "https://auto-flow0.vercel.app/",
    subtitle: "Workflow automation platform",
    points: [
      "Enterprise workflow platform with independent Spring Boot microservices routed through a Spring Cloud Gateway.",
      "End-to-end CI/CD with GitHub Actions (automated tests, multi-stage Docker builds); backend on Railway, frontend on Vercel.",
      "Real-time React dashboard for centralized monitoring of workflows across services.",
    ],
    stack: ["Java", "Spring Boot", "Spring Cloud Gateway", "JPA/Hibernate", "PostgreSQL", "React", "Docker", "GitHub Actions", "Maven", "Railway", "Vercel"],
  },
  {
    tag: "FCPO internship · 2024",
    tone: "pink",
    title: "Medical Chatbot & Clinical Dashboard",
    subtitle: "Patient booking & clinic administration",
    points: [
      "Automated patient appointment booking, cancellations and real-time schedule synchronization.",
      "Clinic administration dashboard for real-time monitoring of consultations and clinical KPIs.",
    ],
    stack: ["React", "Symfony", "MySQL", "REST API", "Git", "GitHub"],
  },
  {
    tag: "Web app · 2023",
    tone: "lilac",
    title: "Assemblee",
    subtitle: "Workspace & room management system",
    points: [
      "Interactive scheduling calendars and admin controls for room booking.",
      "Streamlined reservation flow that eliminated double-bookings.",
    ],
    stack: ["PHP", "MySQL", "HTML5", "CSS3", "Bootstrap"],
  },
];

export const certifications = [
  {
    issuer: "Meta",
    title: "Back-End Development Certificate",
    text: "APIs, databases and server-side development.",
    url: "https://www.coursera.org/account/accomplishments/records/IBMQTFGQXPE7",
  },
  {
    issuer: "Meta",
    title: "Front-End Development Certificate",
    text: "Modern frontend development with React and responsive UI design.",
    url: "https://coursera.org/share/8007b788fe61facc534b24cce7dad74f",
  },
  {
    issuer: "Meta",
    title: "Programming with JavaScript",
    text: "Core algorithms, data structures and asynchronous JavaScript.",
    url: "https://coursera.org/verify/X4266WYU2AQE",
  },
  {
    issuer: "HackerRank",
    title: "Java (Basic)",
    text: "Object-oriented programming, data structures and core Java.",
    url: "https://www.hackerrank.com/certificates/c8db9bd01fe5",
  },
  {
    issuer: "Dubai Future Foundation",
    title: "One Million AI Prompters",
    text: "Prompt engineering and applied generative AI workflows.",
    url: "https://www.linkedin.com/in/oumayma-maili/details/certifications/",
  },
];

export const featuredAchievement = {
  type: "Hackathon · 2nd place",
  text: "Awarded 2nd place at OrientalHack 2.0 for engineering an intelligent WhatsApp agent that helps local cooperatives distribute their products.",
  title: "OrientalHack 2.0",
  sub: "Hackathon podium",
  url: "https://www.linkedin.com/in/oumayma-maili/details/certifications/",
};

export const achievements = [
  {
    type: "Speaker",
    title: "BlablaConf 6.0 — Day 1: UX, Web & Mobile",
    text: "Gave a talk titled \"From Idea to Design\" at BlablaConf 6.0 (GeeksBlaBla), presented to the Moroccan and international tech community.",
    url: "https://www.youtube.com/watch?v=Ow4NlJhTftw&t=14315s",
    cta: "Watch my talk",
  },
  {
    type: "Finalist",
    title: "Pentathon Hackathon — ENSAO",
    text: "Developed AtlasGuardian, an AI-powered emergency disaster response and management platform.",
    url: "https://www.linkedin.com/in/oumayma-maili/details/certifications/",
  },
  {
    type: "Community",
    title: "Fondation Omar Ibn Abdelaziz",
    text: "Active member promoting digital literacy and scientific education (Maison des Sciences de l'Oriental).",
    url: "https://www.linkedin.com/in/oumayma-maili/",
  },
];
